import { createBrowserRouter, redirect } from "react-router";
import { createElement, lazy, Suspense } from "react";

import { AuthProvider, useAuth } from "./AuthContext";
const AdministrationPage = lazy(() => import("./components/AdministrationPage").then((module) => ({ default: module.AdministrationPage })));
const PlatformPage = lazy(() => import("./components/PlatformPage").then((module) => ({ default: module.PlatformPage })));
const PlatformStatusPage = lazy(() => import("./components/PlatformStatusPage").then((module) => ({ default: module.PlatformStatusPage })));
const PlatformDocViewer = lazy(() => import("./components/PlatformDocViewer").then((module) => ({ default: module.PlatformDocViewer })));
const AskMeridianPage = lazy(() => import("./components/AskMeridianPage").then((module) => ({ default: module.AskMeridianPage })));
const ContextInterviewPage = lazy(() => import("./components/ContextInterviewPage").then((module) => ({ default: module.ContextInterviewPage })));
const MyMeridianPage = lazy(() => import("./components/MyMeridianPage").then((module) => ({ default: module.MyMeridianPage })));
const DataPage = lazy(() => import("./components/DataPage").then((module) => ({ default: module.DataPage })));
const CompanyPage = lazy(() => import("./components/company/CompanyPage").then((module) => ({ default: module.CompanyPage })));
const DataSourcesPage = lazy(() => import("./components/DataSourcesPage").then((module) => ({ default: module.DataSourcesPage })));
const HierarchiesPage = lazy(() => import("./components/HierarchiesPage").then((module) => ({ default: module.HierarchiesPage })));
const MappingAtlasPage = lazy(() => import("./components/MappingAtlasPage").then((module) => ({ default: module.MappingAtlasPage })));
const ReconciliationBoardPage = lazy(() => import("./components/ReconciliationBoardPage").then((module) => ({ default: module.ReconciliationBoardPage })));
const MeridianPage = lazy(() => import("./components/MeridianPage").then((module) => ({ default: module.MeridianPage })));
const MeridiansPage = lazy(() => import("./components/MeridiansPage").then((module) => ({ default: module.MeridiansPage })));
const ModelDiscoveryPage = lazy(() => import("./components/DiscoveryEntryPage").then((module) => ({ default: module.DiscoveryEntryPage })));
const DiscoveryCanvasPage = lazy(() => import("./components/DiscoveryCanvasPage").then((module) => ({ default: module.DiscoveryCanvasPage })));
const FormsPage = lazy(() => import("./components/FormsPage").then((module) => ({ default: module.FormsPage })));
const FinancialReportsPage = lazy(() => import("./components/FinancialReportsPage").then((module) => ({ default: module.FinancialReportsPage })));
const FormDetailPage = lazy(() => import("./components/FormDetailPage").then((module) => ({ default: module.FormDetailPage })));
const ForecastPage = lazy(() => import("./components/ForecastPage").then((module) => ({ default: module.ForecastPage })));
const AlertsPage = lazy(() => import("./components/AlertsPage").then((module) => ({ default: module.AlertsPage })));
const HomePageV2 = lazy(() => import("./components/HomePageV2").then((module) => ({ default: module.HomePageV2 })));
const WhatToLookAtPage = lazy(() => import("./components/WhatToLookAtPage").then((module) => ({ default: module.WhatToLookAtPage })));
import { IndexRouter } from "./components/IndexRouter";
import { LoginPage } from "./components/LoginPage";
const LinkSsoPage = lazy(() => import("./components/LinkSsoPage").then((module) => ({ default: module.LinkSsoPage })));
const SetupPasswordPage = lazy(() => import("./components/SetupPasswordPage").then((module) => ({ default: module.SetupPasswordPage })));
const SignupPage = lazy(() => import("./components/SignupPage").then((module) => ({ default: module.SignupPage })));
const TimelinePage = lazy(() => import("./components/TimelinePage").then((module) => ({ default: module.TimelinePage })));
const ModelInsightsPage = lazy(() => import("./components/ModelInsightsPage").then((module) => ({ default: module.ModelInsightsPage })));
const StarterLandingPage = lazy(() => import("./components/StarterLandingPage").then((module) => ({ default: module.StarterLandingPage })));
const MetricsSettingsPage = lazy(() => import("./components/MetricsSettingsPage").then((module) => ({ default: module.MetricsSettingsPage })));
const PricingPage = lazy(() => import("./components/PricingPage").then((module) => ({ default: module.PricingPage })));
const SchemaVizDemo = lazy(() => import("./components/SchemaVizDemo").then((module) => ({ default: module.SchemaVizDemo })));
const ModelBlueprintPreviewDemo = lazy(() => import("./components/ModelBlueprintPreviewDemo").then((module) => ({ default: module.ModelBlueprintPreviewDemo })));
import { RequireAuth } from "./components/RequireAuth";
const EditorialShell = lazy(() => import("./components/editorial/EditorialShell").then((module) => ({ default: module.EditorialShell })));
const EditorialTodayPage = lazy(() => import("./components/editorial/EditorialTodayPage").then((module) => ({ default: module.EditorialTodayPage })));
const EditorialDataPage = lazy(() => import("./components/editorial/EditorialSectionPages").then((module) => ({ default: module.EditorialDataPage })));
const EditorialDecisionsPage = lazy(() => import("./components/editorial/EditorialSectionPages").then((module) => ({ default: module.EditorialDecisionsPage })));
const EditorialModelsPage = lazy(() => import("./components/editorial/EditorialSectionPages").then((module) => ({ default: module.EditorialModelsPage })));
const EditorialPlanPage = lazy(() => import("./components/editorial/EditorialSectionPages").then((module) => ({ default: module.EditorialPlanPage })));
const HomePage = lazy(() => import("./components/HomePage").then((module) => ({ default: module.HomePage })));
import { RootLayout } from "./components/RootLayout";
const DataStoryPage = lazy(() => import("./components/DataStoryPage").then((module) => ({ default: module.DataStoryPage })));
const DraftsPage = lazy(() => import("./components/DraftsPage").then((module) => ({ default: module.DraftsPage })));
const V3Shell = lazy(() => import("./components/v3/V3Shell").then((module) => ({ default: module.V3Shell })));
const HomePageV3 = lazy(() => import("./components/v3/HomePageV3").then((module) => ({ default: module.HomePageV3 })));
const DataPageV3 = lazy(() => import("./components/v3/DataPageV3").then((module) => ({ default: module.DataPageV3 })));
const DataWorkspaceV3 = lazy(() => import("./components/datav3/DataWorkspaceV3").then((module) => ({ default: module.DataWorkspaceV3 })));
import { CompanionProvider } from "./components/companion/CompanionProvider";
import { CompanionLayer } from "./components/companion/CompanionLayer";
const EditorialPreviewPage = lazy(() => import("./components/editorial/EditorialPreviewPage").then((module) => ({ default: module.EditorialPreviewPage })));
const FolioBriefPreviewPage = lazy(() => import("./components/folio/FolioBriefPreviewPage").then((module) => ({ default: module.FolioBriefPreviewPage })));
const SalesJourneyPage = lazy(() => import("./components/sales/SalesJourneyPage").then((module) => ({ default: module.SalesJourneyPage })));

// Wrap a shell in the Companion layer: the provider sits ABOVE the shell so it
// survives in-shell navigation, and the overlay renders as a sibling beside the
// page. Mounted per protected root (each shell is a separate top-level route),
// so the one calm presence follows the user across every page in that shell.
// Renders nothing when the Companion flag is off — Watch + Bell take over.
function withCompanion(shell: React.ReactElement): React.ReactElement {
  return createElement(
    CompanionProvider,
    null,
    shell,
    createElement(CompanionLayer),
  );
}

// AuthProvider sits at the very top so /login can read auth state too
// (to short-circuit when already signed in). The login page itself is
// the one route that's NOT wrapped in RequireAuth — everything else
// requires a valid session cookie.
function AuthShell({ children }: { children: React.ReactNode }) {
  return createElement(AuthProvider, null, createElement(Suspense, { fallback: createElement("p", { role: "status", className: "p-8 text-sm text-slate-500" }, "Opening Meridian…") }, children));
}

/** Presentation-only switch. The route tree and every backend contract remain
 * shared, so Labs and Production can run the same image while choosing a
 * different default or overriding one workspace during rollout. */
function ExperienceRoot() {
  const { me } = useAuth();
  if (me?.workspace.experience_mode === "briefing") {
    return createElement(EditorialShell);
  }
  return withCompanion(createElement(RootLayout));
}

function ExperienceHome() {
  const { me } = useAuth();
  return me?.workspace.experience_mode === "briefing"
    ? createElement(EditorialTodayPage)
    : createElement(HomePage);
}

function ExperienceData() {
  const { me } = useAuth();
  return me?.workspace.experience_mode === "briefing"
    ? createElement(EditorialDataPage)
    : createElement(DataPage);
}

function ExperienceModels() {
  const { me } = useAuth();
  return me?.workspace.experience_mode === "briefing"
    ? createElement(EditorialModelsPage)
    : createElement(MeridiansPage);
}

function ExperiencePlan() {
  const { me } = useAuth();
  return me?.workspace.experience_mode === "briefing"
    ? createElement(EditorialPlanPage)
    : createElement(ForecastPage);
}

function ExperienceDecisions() {
  const { me } = useAuth();
  return me?.workspace.experience_mode === "briefing"
    ? createElement(EditorialDecisionsPage)
    : createElement(WhatToLookAtPage);
}

function ProtectedRoot() {
  return createElement(
    AuthShell,
    null,
    createElement(RequireAuth, null, createElement(ExperienceRoot)),
  );
}

// V3 design preview — same auth gating as ProtectedRoot but rendered
// inside the redesigned V3Shell (its own sidebar + top bar) so the new
// look can be evaluated end-to-end without touching the classic shell.
function ProtectedV3Root() {
  return createElement(
    AuthShell,
    null,
    createElement(RequireAuth, null, withCompanion(createElement(V3Shell))),
  );
}

// "Data 2 (preview)" — the redesigned Data tab. It carries its OWN full
// shell (sidebar + top bar), so it mounts as a top-level protected route
// rather than nesting inside the classic RootLayout (which would double
// the sidebar). Auth-gated like every other protected surface.
function ProtectedDataV3Root() {
  return createElement(
    AuthShell,
    null,
    createElement(RequireAuth, null, withCompanion(createElement(DataWorkspaceV3))),
  );
}

function PublicShell({ children }: { children: React.ReactNode }) {
  // /login still needs AuthProvider so the form can call `login()` and
  // the redirect-when-already-authenticated check can fire.
  return createElement(AuthShell, null, children);
}

function LoginShell() {
  return createElement(PublicShell, null, createElement(LoginPage));
}

function SignupShell() {
  // /signup mirrors /login — public, AuthProvider-wrapped so the form
  // can call signup() and the already-authenticated bounce can fire.
  return createElement(PublicShell, null, createElement(SignupPage));
}

function SetupPasswordShell() {
  // /setup-password is the landing for admin-issued magic-link
  // invites. Same public + AuthProvider wrapping as /signup so
  // acceptInvite can hydrate the auth state on success.
  return createElement(PublicShell, null, createElement(SetupPasswordPage));
}

function PricingShell() {
  // Pricing is reachable both from inside the app (sales prompt) and
  // as a public landing — keep it outside RequireAuth so prospects
  // who haven't logged in can still see it.
  return createElement(PublicShell, null, createElement(PricingPage));
}

function IndexShell() {
  // `/` is now public: anonymous visitors are bounced to the static
  // marketing landing page (apps/web/public/landing.html) via a full
  // browser navigation; authenticated visitors land at /home via
  // React Router. AuthProvider has to be in scope so IndexRouter can
  // read auth state.
  return createElement(PublicShell, null, createElement(IndexRouter));
}

// Five pillars: Home, Data, Ask Meridian, Develop, Administration.
// Login is unauthenticated; everything else is gated by RequireAuth
// (which reads the AuthContext populated by `/auth/me`).
//
// `/` is public (IndexShell → IndexRouter): anonymous visitors get
// the marketing landing page, authenticated visitors are redirected
// to `/home`. The dashboard is reachable only via `/home` now —
// internal links to `/` still work via the IndexRouter bounce.
export const router = createBrowserRouter([
  { path: "/", Component: IndexShell },
  { path: "/login", Component: LoginShell },
  { path: "/link-sso", element: createElement(AuthShell, null, createElement(RequireAuth, null, createElement(LinkSsoPage))) },
  { path: "/signup", Component: SignupShell },
  { path: "/setup-password", Component: SetupPasswordShell },
  { path: "/pricing", Component: PricingShell },
  // Public design-fidelity preview for the Matrix + Subway schema
  // views. Renders against a hardcoded sample schema so a Vite-only
  // dev server (no backend) can still exercise both views. Not linked
  // from any product surface — visit /schema-viz-demo directly.
  { path: "/schema-viz-demo", Component: SchemaVizDemo },
  // Backend-free preview of the semantic model approval step. Kept
  // unlinked so visual QA can exercise the flow without an active import.
  { path: "/model-blueprint-preview", Component: ModelBlueprintPreviewDemo },
  // Public design-fidelity preview for the Mapping Atlas. The protected
  // product route lives at /mappings below; this route keeps visual QA
  // independent from API/auth availability.
  { path: "/mapping-atlas-demo", Component: MappingAtlasPage },
  // Backend-free visual QA route for the new Editorial experience. This is
  // deliberately unlinked and uses clearly labelled preview data; production
  // routes continue to read the active workspace through the shared APIs.
  { path: "/editorial-preview", Component: EditorialPreviewPage },
  // Public, backend-free translation of the supplied Meridian Folio brief.
  // It stays separate from the live Editorial experience so the visual
  // direction can be evaluated without changing product behaviour.
  { path: "/folio-brief-preview", Component: FolioBriefPreviewPage },
  // "Data 2 (preview)" — redesigned Data tab in its own full shell.
  { path: "/data2", Component: ProtectedDataV3Root },
  // V3 design preview — redesigned Today + Data pages inside the new
  // V3Shell. Lives on its own top-level branch so the classic
  // RootLayout shell never wraps it. The same pages also mount inside
  // the classic shell as /today3 and /data2 (below) for comparison.
  {
    path: "/v3",
    Component: ProtectedV3Root,
    children: [
      { index: true, loader: () => redirect("/v3/home") },
      { path: "home", Component: HomePageV3 },
      { path: "data", Component: DataPageV3 },
      { path: "*", loader: () => redirect("/v3/home") },
    ],
  },
  {
    path: "/",
    Component: ProtectedRoot,
    children: [
      { path: "home", Component: ExperienceHome },
      { path: "sales-overview", Component: SalesJourneyPage },
      // Comparison build of the redesigned dashboard. Same
      // functionality as /home; new Today look layered on top.
      { path: "today2", Component: HomePageV2 },
      // V3 "Ledger" pages mounted inside the classic shell for
      // side-by-side comparison with /home, /today2 and /data. The
      // pages carry their own canvas background; the full V3 shell
      // experience lives at /v3/*.
      { path: "today3", Component: HomePageV3 },
      { path: "data", Component: ExperienceData },
      { path: "dimensions", loader: () => redirect("/hierarchies") },
      { path: "hierarchies", Component: HierarchiesPage },
      { path: "mappings", Component: MappingAtlasPage },
      { path: "reconcile/:runId", Component: ReconciliationBoardPage },
      { path: "models", Component: ExperienceModels },
      { path: "model-discovery", Component: ModelDiscoveryPage },
      { path: "discovery-canvas", Component: DiscoveryCanvasPage },
      { path: "forms", Component: FormsPage },
      { path: "forms/:formId", Component: FormDetailPage },
      // Company — the annual report as a living context profile
      // (specs/COMPANY_CONTEXT.md). Workspace-level, so it lives beside
      // Data rather than under a model.
      { path: "company", Component: CompanyPage },
      { path: "ask-meridian", Component: AskMeridianPage },
      { path: "context-interview", Component: ContextInterviewPage },
      { path: "my-meridian", Component: MyMeridianPage },
      // Forecast — per-product card surface (FORECAST_METHOD_ROUTER Phase 2).
      // Forecast every series in a dimension and explain each in a sentence.
      { path: "forecast", Component: ExperiencePlan },
      // Forecast-alert management (see/mute/delete standing drift watches).
      { path: "alerts", Component: AlertsPage },
      // /develop was the standalone branching launcher; consolidated
      // into /data on 2026-05-27. Kept as a redirect so existing
      // bookmarks + the legacy /applications + /development redirects
      // below continue to resolve to a real page.
      { path: "develop", loader: () => redirect("/data") },
      { path: "administration", Component: AdministrationPage },
      { path: "platform", Component: PlatformPage },
      // Build status — superuser-only overview of shipped/awaiting/roadmap
      // work, with links into the in-app spec viewer. Both pages self-gate
      // on is_superuser (redirect to /home otherwise).
      { path: "platform/status", Component: PlatformStatusPage },
      { path: "platform/docs", Component: PlatformDocViewer },

      // Settings — admin surfaces grouped under /settings/*. Metrics
      // is the first; future entries (members, billing, ai-instructions)
      // land here too.
      { path: "settings/metrics", Component: MetricsSettingsPage },

      // Mission Library no longer exists as a standalone destination.
      // Existing bookmarks land in Decisions instead.
      { path: "missions/library", loader: () => redirect("/insights") },

      // Decisions — AI-surfaced grounded signals and their next actions.
      { path: "insights", Component: ExperienceDecisions },

      // Model tabs. Backend path params are now keyed on meridian_id
      // (the URL still literally reads /models/...).
      { path: "models/:modelId", Component: MeridianPage },
      { path: "models/:modelId/start", Component: StarterLandingPage },
      { path: "models/:modelId/sources", Component: DataSourcesPage },
      { path: "models/:modelId/reports", Component: FinancialReportsPage },
      { path: "models/:modelId/timeline", Component: TimelinePage },
      { path: "models/:modelId/drafts", Component: DraftsPage },
      { path: "models/:modelId/insights", Component: ModelInsightsPage },
      // Data Story — presentable narrative from the model's findings.
      { path: "models/:modelId/story", Component: DataStoryPage },

      // Legacy redirects — loader-style so this file stays JSX-free.
      { path: "applications", loader: () => redirect("/data") },
      { path: "published", loader: () => redirect("/data") },
      { path: "development", loader: () => redirect("/data") },

      // Catchall — anything an authenticated user lands on that
      // doesn't match the routes above bounces to /home rather than
      // showing React Router's default "Hey developer 👋" error UI.
      { path: "*", loader: () => redirect("/home") },
    ],
  },
]);
